import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as dependentActions from "../redux/actions/dependentActions";
import * as userDetailActions from "../redux/actions/userDetailActions";
import AllDependentsDashboardComponent from "../components/AllDependentsDashboardComponent";
import A12Y_CONST from "../common/a12yConst";
import LoaderFullScreen from "../components/LoaderFullScreenComponent";
import PopUpWelcomeAdvocord from "../components/PopUpWelcomeAdvocord";
import { secureClient } from "../config/axiosClient";

// ─── Demo / test data ────────────────────────────────────────────────────────
// Uses randomuser.me portrait CDN (static, highly available).
// Indices 60–90 reliably return elderly/senior-looking photos.


class AllDependentsDashboardScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      pageError: "",
    };
  }

  componentDidMount = async () => {
    const advocateId = this.props.userState?.userInfo?.advocate_id || this.props.userState?.userInfo?.id;
    if (advocateId) {
      if (
        this.props.isFetchDependnet
      ) {
        await this.props.getAllDependent(advocateId);
        await this.props.setIsFetchDependnet(false)
      }
    }
  };

  handleNavigate = async (dependent, route, state) => {
    const isSubscriptionRoute = route === A12Y_CONST.ROUTE.ONE_TIME_SUBSCRIPTION;
    if (
      !isSubscriptionRoute &&
      dependent &&
      !String(dependent.id).startsWith("mock-") &&
      dependent.id !== this.props.dependent?.id
    ) {
      await this.props.switchDependent(dependent);
    }
    if (state) {
      this.props.history.push({ pathname: route, state });
    } else {
      this.props.history.push(route);
    }
  };




  handleAddDependent = async () => {
    this.setState({ loading: true });

    const subDetails = this.props.userSubscriptionAllDetails;
    const isTrialing = subDetails?.trial_period === true &&
      (subDetails?.status?.toLowerCase() === 'trialing' ||
        subDetails?.subscription_details?.subscription_status?.toLowerCase() === 'trialing');

    if (!isTrialing) {
      try {
        let res = await this.props.getProration();
        if (res && !res.success) {
          this.setState({ loading: false, pageError: res.errMsg });
          setTimeout(() => this.setState({ pageError: '' }), 5000);
          return;
        }
      } catch (error) {
        this.setState({ loading: false, pageError: "Unable to calculate proration!" });
        setTimeout(() => this.setState({ pageError: '' }), 5000);
        return;
      }
    }

    this.setState({ loading: false });
    this.props.history.push(A12Y_CONST.ROUTE.NEW_DEPENDENT);
  };

  trialReminderBoxHide = async (status) => {
    await this.props.trialReminder(status);
  };

  welcomePopUpClose = async (status) => {
    await this.props.welcomePopUp(status);
  };

  surveyPopUpHandle = async (status) => {
    await this.props.surveyRolePopUp(status);
  };

  surveySectionVisible = async (status) => {
    await this.props.surveyPopUp(status);
  };

  billingScreenHandle = async (toSubscriptionTab = false) => {
    await this.props.goToBillingScreen(true);
    this.props.history.push({
      pathname: A12Y_CONST.ROUTE.ADVOCATE_PROFILE_MY_ACCOUNT,
      state: { [toSubscriptionTab === true ? 'fromSubscriptionScreen' : 'fromBillingScreen']: true },
    });
  };

  handleSurvey = async (data) => {
    let surveyData = {};
    if (data?.survey?.title) surveyData.Subscriber_Funnel_Source = data?.survey?.title;
    if (data?.role?.title) surveyData['Any-other-field'] = data?.role?.title;
    await secureClient.post(A12Y_CONST.API_ENDPOINT.KLAVIYO_STATUS, surveyData);
    await this.props.surveyPopUp(false);
    await this.props.surveyRolePopUp(false);
    let surveyTitle = data?.referralCourt ? data?.survey?.title + ' ' + data?.referralCourt : data?.survey?.title;
    window.dataLayer.push({
      'survey': surveyTitle,
      'advocate_type': data?.role?.title,
    });
  };

  render() {

    const allDependentList = this.props.dependentList || [];
    const subscription = this.props.subscription || [];

    const allActiveDependent = allDependentList.filter(d => d.status === 0);

    // Calculate total quantity from active subscriptions
    const totalQuantity = (Array.isArray(subscription) ? subscription : [])
      .filter(s => s.status === "active" || s.status === "trialing")
      .reduce((acc, sub) => {
        const subQty = sub.items?.reduce((iAcc, item) => iAcc + (item.quantity || 0), 0) || 0;
        return acc + subQty;
      }, 0);

    const isTrialing = (Array.isArray(subscription) ? subscription : []).some(s => s.status === "trialing");
    const isQuotaFull = isTrialing ? false : (allActiveDependent.length >= totalQuantity);
    const isQuotaExceeded = isTrialing ? false : (allActiveDependent.length > totalQuantity);

    const subDetails = this.props.userSubscriptionAllDetails || {};
    const subStatus = subDetails.cancel_at_period_end
      ? "CANCELLED"
      : (subDetails.status || subDetails.subscription_details?.subscription_status);
    const isTrialExpired = subDetails.is_trial_expired;
    const isSubscriptionExpired = subStatus === A12Y_CONST.TEXT.EXPIRED || subStatus === A12Y_CONST.TEXT.FAILED_PAYMENT;
    const shouldDisable = (!this.props.dependent?.access?.can_update) ? false : (isTrialExpired || isSubscriptionExpired || isQuotaExceeded);
    return (
      // loader while alldependent list is fetching
      this.state.loading ? (
        <div className="myProfileAccount animationall mainRightSidebare">
          <div className="rightPanelWidhtSidebar">
            <div className="rightPanelWidhtSidebarContainer fullWidth">
              <LoaderFullScreen />
            </div>
          </div>
        </div>
      ) : (
        <div className="myProfileAccount animationall mainRightSidebare">
          <div className="rightPanelWidhtSidebar">
            <div className="rightPanelWidhtSidebarContainer fullWidth">
              <AllDependentsDashboardComponent
                dashboardError={this.state.pageError}
                activationFee={this.props.activationFee}
                excemptAllFee={this.props.excemptAllFee}
                dependentList={allDependentList}
                loading={this.props.loading}
                onNavigate={this.handleNavigate}
                onAddDependent={this.handleAddDependent}
                isQuotaFull={isQuotaFull}
                isQuotaExceeded={isQuotaExceeded}
                shouldDisable={shouldDisable}
                totalAllowed={totalQuantity}
                currentCount={allActiveDependent.length}
                userInfo={this.props.userState?.userInfo || {}}
                dependent={this.props.dependent || {}}
                subscriptionType={subStatus}
                subscription={subDetails}
                userSubscriptionAllDetails={this.props.userSubscriptionAllDetails}
                welcomePopUpStatus={this.props.IsWelcomePopUp}
                isTrialReminder={this.props.isTrialReminder}
                IsSurveyRolePopUp={this.props.IsSurveyRolePopUp}
                IsSurvey_PopUp={this.props.IsSurvey_PopUp}
                welcomePopUpClose={this.welcomePopUpClose}
                surveyPopUpHandle={this.surveyPopUpHandle}
                surveySectionVisible={this.surveySectionVisible}
                trialReminderBoxHide={this.trialReminderBoxHide}
                billingScreenHandle={this.billingScreenHandle}
                handleSurvey={this.handleSurvey}
                refreshList={async () => {
                  const advocateId = this.props.userState?.userInfo?.advocate_id || this.props.userState?.userInfo?.id;
                  if (advocateId) {
                    await this.props.getSubscription();
                    await this.props.getAllDependent(advocateId);
                  }
                }}
              />

              {isQuotaExceeded && totalQuantity > 0 && this.state.isQuotaPopUpVisible && this.props.userState?.userInfo?.user_type !== 1 && (
                <PopUpWelcomeAdvocord
                  popUpStatus={true}
                  popUpType={A12Y_CONST.LABEL.QUOTA_LIMIT_REACHED}
                  hidePopUp={() => {
                    this.setState({ isQuotaPopUpVisible: false });
                    this.handleNavigate(null, A12Y_CONST.ROUTE.ADVOCATE_PROFILE_MY_ACCOUNT);
                  }}
                  totalAllowed={totalQuantity}
                  currentCount={allActiveDependent.length}
                  userInfo={this.props.userState?.userInfo || {}}
                  dependent={this.props.dependent || {}}
                />
              )}
            </div>
          </div>
        </div>
      ))
  }
}

const mapStateToProps = (state) => ({
  userState: state.userDetailReducer.userState,
  dependentList: state.dependentReducer.dependentList,
  loading: state.dependentReducer.loading,
  dependent: state.dependentReducer.dependent,
  subscription: state.userDetailReducer.subscription,
  userSubscriptionAllDetails: state.userDetailReducer.userSubscriptionAllDetails,
  isTrialReminder: state.userDetailReducer.isTrialReminder,
  IsWelcomePopUp: state.userDetailReducer.IsWelcomePopUp,
  IsSurveyRolePopUp: state.userDetailReducer.IsSurveyRolePopUp,
  IsSurvey_PopUp: state.userDetailReducer.IsSurvey_PopUp,
  errMsg: state.dependentReducer.errMsg,
  isError: state.dependentReducer.isError,
  activationFee: state.userDetailReducer.activationFee,
  excemptAllFee: state.userDetailReducer.excemptAllFee,
  isFetchDependnet: state.dependentReducer.isFetchDependnet,
});

const mapDispatchToProps = (dispatch) => ({
  getAllDependent: (advocate_id) =>
    dispatch(dependentActions.getAllDependent(advocate_id)),
  switchDependent: (dependent) =>
    dispatch(dependentActions.switchDependent(dependent)),
  getSubscription: () =>
    dispatch(userDetailActions.getSubscription()),
  getProration: () =>
    dispatch(userDetailActions.getProration()),
  trialReminder: (status) =>
    dispatch(userDetailActions.trialReminder(status)),
  welcomePopUp: (status) =>
    dispatch(userDetailActions.welcomePopUp(status)),
  surveyRolePopUp: (status) =>
    dispatch(userDetailActions.surveyRolePopUp(status)),
  surveyPopUp: (status) =>
    dispatch(userDetailActions.surveyPopUp(status)),
  goToBillingScreen: (status) =>
    dispatch(userDetailActions.goToBillingScreen(status)),
  setIsFetchDependnet: (status) =>
    dispatch(dependentActions.setIsFetchDependnet(status)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AllDependentsDashboardScreen)
);
